import React from 'react';
import { FaGithub, FaLinkedinIn } from 'react-icons/fa';
import { HiArrowDown, HiOutlineLocationMarker } from 'react-icons/hi';
import { HashLink } from 'react-router-hash-link';
import { contactsData } from '../../../data/contactsData';
import { headerData } from '../../../data/headerData';
import HeroScene from '../../helper/hero-scene';
import './landing.css';

function LandingUI() {
    return (
        <section className='landing' id='top' aria-labelledby='landing-title'>
            <div className='landing__grid container'>
                <div className='landing__copy'>
                    <p className='landing__status'>
                        <span className='landing__dot' aria-hidden='true' />
                        {headerData.company}
                    </p>
                    <h1 id='landing-title' className='display landing__title'>
                        {headerData.name}
                    </h1>
                    <p className='landing__role'>{headerData.role}</p>
                    <p className='landing__intro'>{headerData.intro}</p>

                    <div className='landing__actions'>
                        <HashLink to='/#projects' className='btn btn--primary'>
                            View Projects
                            <HiArrowDown aria-hidden='true' />
                        </HashLink>
                        <HashLink to='/#contacts' className='btn'>
                            Contact
                        </HashLink>
                    </div>

                    <div className='landing__meta'>
                        <span className='landing__place'>
                            <HiOutlineLocationMarker aria-hidden='true' />
                            {contactsData.address}
                        </span>
                        <span className='landing__social'>
                            {contactsData.github && (
                                <a href={contactsData.github} target='_blank' rel='noreferrer' aria-label='GitHub profile'>
                                    <FaGithub aria-hidden='true' />
                                </a>
                            )}
                            {contactsData.linkedIn && (
                                <a href={contactsData.linkedIn} target='_blank' rel='noreferrer' aria-label='LinkedIn profile'>
                                    <FaLinkedinIn aria-hidden='true' />
                                </a>
                            )}
                        </span>
                    </div>

                    <ul className='landing__stack' aria-label='Core stack'>
                        {headerData.coreStack.map((item) => (
                            <li key={item} className='chip'>{item}</li>
                        ))}
                    </ul>
                </div>

                <div className='landing__portrait'>
                    <HeroScene className='landing__scene' />
                    <div className='landing__frame'>
                        <picture>
                            <source
                                srcSet={`${headerData.imageSmall} 320w, ${headerData.image} 640w`}
                                sizes='(max-width: 860px) 62vw, 400px'
                                type='image/webp'
                            />
                            <img
                                src={headerData.imageFallback}
                                alt={headerData.imageAlt}
                                width='640'
                                height='800'
                                fetchpriority='high'
                                decoding='async'
                            />
                        </picture>
                        <div className='landing__scanwrap' aria-hidden='true'>
                            <span className='landing__scan' />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default LandingUI;
